module.exports = __webpack_public_path__ + "arrowLeft.d0f5fb63.png";